import type { AxiosInstance } from 'axios';
import type { Users } from './interfaces/index.js';
import { transformDates } from './transformers/index.js';

export interface GetUserBrandsResponse {
  brands: {
    identifier: string;
    name: string;
    productBrand?: {
      id: string;
      name: string;
      displayName: string | null;
    } | null;
    indication?: {
      id: string;
      name: string;
      displayName: string | null;
    } | null;
    therapeuticArea?: {
      id: string;
      name: string;
      displayName: string | null;
    } | null;
    productBrands?: Array<{
      id: string;
      name: string;
      displayName: string | null;
    }>;
    drugClasses?: Array<{
      id: string;
      name: string;
      displayName: string | null;
    }>;
    genericDrugs?: Array<{
      id: string;
      name: string;
      displayName: string | null;
    }>;
    drugClassProductBrandMappings?: Array<{
      drugClass: {
        id: string;
        name: string;
        displayName: string | null;
      };
      productBrands: Array<{
        id: string;
        name: string;
        displayName: string | null;
      }>;
    }>;
  }[];
}

export interface GetUserApplicationsResponse {
  // Map of brand identifier to applications for that brand
  [brandIdentifier: string]: {
    identifier: string;
    name: string;
    icon: string | null;
    isDefault?: boolean;
  }[];
}
export interface GetUserRateLimitingResponse {
  allowed: boolean;
  limit: number | null;
  current: number;
}

export class UsersClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  getUserBrands = async (): Promise<GetUserBrandsResponse> => {
    const response = await this.authenticatedClient.get<GetUserBrandsResponse>('/users/brands');
    return response.data;
  };

  getUserApplications = async (): Promise<GetUserApplicationsResponse> => {
    const response = await this.authenticatedClient.get<GetUserApplicationsResponse>('/users/applications');
    return response.data;
  };

  getRecentFiles = () => {
    return this.authenticatedClient.get<Users.GetRecentFiles.Response>(`/users/recent-files`, {
      transformResponse: transformDates,
    });
  };

  getRateLimiting = async (): Promise<GetUserRateLimitingResponse> => {
    const response = await this.authenticatedClient.get<GetUserRateLimitingResponse>('/users/rate-limiting');
    return response.data;
  };
}

export default UsersClient;